import {
    FETCH_PROJECT_REMINDER_MAILS_REQUEST,
    FETCH_PROJECT_REMINDER_MAILS_SUCCESS,
    FETCH_PROJECT_REMINDER_MAILS_FALUIRE,
    SAVE_PROJECT_REMINDER_MAIL_REQUEST,
    SAVE_PROJECT_REMINDER_MAIL_DONE,
} from './projectReminderMailsTypes'

const initialState = {
    loading: false,
    saving: false,
    projectReminderMails: [],
    // Project the rows in state belong to, so another project's reminders can
    // never stay on screen (deleting one of those would hit the wrong project).
    projectId: null,
    error: '',
}

const sameProject = (a, b) => String(a) === String(b)

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROJECT_REMINDER_MAILS_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
                projectId: action.payload,
                projectReminderMails: sameProject(action.payload, state.projectId)
                    ? state.projectReminderMails
                    : [],
            }
        case FETCH_PROJECT_REMINDER_MAILS_SUCCESS:
            // Drop a response that lost the race to a newer project's request.
            if (!sameProject(action.projectId, state.projectId)) {
                return state
            }
            return {
                ...state,
                loading: false,
                projectReminderMails: action.payload,
                error: '',
            }
        case FETCH_PROJECT_REMINDER_MAILS_FALUIRE:
            if (!sameProject(action.projectId, state.projectId)) {
                return state
            }
            return {
                ...state,
                loading: false,
                projectReminderMails: [],
                error: action.payload,
            }
        case SAVE_PROJECT_REMINDER_MAIL_REQUEST:
            return {
                ...state,
                saving: true,
            }
        case SAVE_PROJECT_REMINDER_MAIL_DONE:
            return {
                ...state,
                saving: false,
            }
        default:
            return state
    }
}

export default reducer
